import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCog, faDownload, faPencil, faTrashAlt,
} from '@fortawesome/pro-light-svg-icons'

import {
  DashboardModuleListItem, IconWithMenu, Link,
} from '@domain-group/suit-theme'

import useTemplatePage from '@hooks/useTemplatePage'

import type { TemplatePageModel } from '@models/templatePage'

interface TemplatePageListItemProps {
  showBrandTitle?: boolean,
  templatePage: TemplatePageModel,
}

const TemplatePageListItem = (props: TemplatePageListItemProps) => {
  const { showBrandTitle, templatePage: initTemplatePage } = props

  const templatePagePayload = useTemplatePage(initTemplatePage)

  const { brand, templatePage: { id, title } } = templatePagePayload

  return (
    <DashboardModuleListItem
      boxProps={{ paddingX: 'large' }}
      title={title}
      secondaryText={showBrandTitle ? brand?.title : ''}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        #{id}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/* <DashboardModuleListItem.Actions>
        <IconWithMenu
          boxProps={{ position: 'relative', marginRight: 'medium' }}
          icon={(
            <Link greyLink>
              <FontAwesomeIcon icon={faCog} />
            </Link>
          )}
          shouldUsePortal
        >
          <IconWithMenu.Menu closeOnClick>
            <Link key="edit">
              <FontAwesomeIcon icon={faPencil} /> Edit Template
            </Link>

            <Link
              key="delete"
            // onClick={() => console.log("to do")}
            >
              <FontAwesomeIcon icon={faTrashAlt} /> Remove Template
            </Link>

            <Link
              key="download"
            // onClick={() => console.log("to do")}
            >
              <FontAwesomeIcon icon={faDownload} /> Download Preview
            </Link>

          </IconWithMenu.Menu>
        </IconWithMenu>

        <DashboardModuleListItem.Icon
          // href={`${editProviderUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
      </DashboardModuleListItem.Actions> */}
    </DashboardModuleListItem>
  )
}

export default TemplatePageListItem
